import { type FC, type ReactElement, useEffect, useRef, useState } from "react";

interface TimeTillVisibleProvider {
    timeTillVisibleInSeconds: number;
    children: ReactElement<unknown>;
}

export const TimeTillVisibleProvider: FC<TimeTillVisibleProvider> = ({ timeTillVisibleInSeconds, children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const isInitialMountRef = useRef(true);

    useEffect(() => {
        let timeout: NodeJS.Timeout | null = null;

        if (isInitialMountRef.current) {
            isInitialMountRef.current = false;

            timeout = setTimeout(() => {
                setIsVisible(true);
            }, timeTillVisibleInSeconds * 1000);
        }

        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [timeTillVisibleInSeconds, setIsVisible]);

    if (!isVisible) {
        return null;
    }

    return children;
};
